<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm01">
<a id="page01">
<div class="chapterHead">
<h2 class="chapterTitle"><span class="bold">“We both know this marriage is one of convenience, a business arrangement.”</span></h2></div>
<div class="chapterBody">
<p class="paraNoIndent1">Exactly what Elizabeth wanted to hear, wasn’t it? Then why did Ted’s words sting? Well, business arrangement or not, how could she wed a stranger? “I…I can’t marry you.”</p>
<p class="paraNoIndent1">Ted turned to her, searching her face. His expression softened. He took her hand in his. His gentle touch gave her a measure of comfort…and far too much awareness of the man.</p>
<p class="paraNoIndent1">“This isn’t easy for either of us,” he said, his eyes filling with tenderness. “But I want you to know I’ll be kind to you. Work hard to provide for you. I don’t have much, but all I have is yours.”</p>
<p class="paraNoIndent1">Elizabeth didn’t want to marry, but what choice did she have? She didn’t have a penny to her name. Didn’t have a single idea what to do.</p>
<p class="paraNoIndent1">A proposal would solve all her problems.</p>
<p class="paraNoIndent1">Except this proposal was offered to another woman. What would Ted say once he knew her true identity?</p>
</div>
</a></div>
<a id="page01">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// substitutebridethe_fm01.vue?5ee4b14a